import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {JobTaskService} from '../../shared/services/job-task/job-task.service';
import {MatTableDataSource} from '@angular/material/table';
import {environment} from '../../../environments/environment';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import {faInfoCircle, faFileExcel, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {ToastrService} from 'ngx-toastr';
import {EventMessageService} from '../../shared/services/server-sent-event/event-message.service';
import {ExportCsvTaskModalComponent} from './export-csv-task-modal/export-csv-task-modal.component';
import {TranslateService} from '@ngx-translate/core';
import {JobTaskStatus} from '../../shared/enum/job-task-status.enum';
import {ProjectExportCsvComponent} from '../project/project-export-csv/project-export-csv.component';
import {StatesService} from '../../shared/services/state/states.service';
import {JobTask} from '../../shared/classes/job-task/job-task';
import {ActivatedRoute} from '@angular/router';
import {DataType} from '../../shared/enum/data-type.enum';
import {ProjectService} from '../../shared/services/project/project.service';
import {LevelService} from '../../shared/services/level/level.service';
import {Level} from '../../shared/classes/level/level';

@Component({
  selector: 'app-job-task',
  templateUrl: './export-csv-task.component.html',
  styleUrls: ['./export-csv-task.component.css']
})
export class ExportCsvTaskComponent implements OnInit, OnDestroy {

  public displayedColumns: string[] = ['job_task_id', 'job_start_date', 'project_id', 'project_name', 'resume', 'progression',
    'status', 'actions'];
  public jobTaskMatTableDataSource: MatTableDataSource<any>;
  public isLoading = true;
  public pageSizeOptions = environment.pageSizeOptions;
  public pageSize = environment.pageSize;
  public faInfoCircle = faInfoCircle;
  public faFileExcel = faFileExcel;
  public faTrashAlt = faTrashAlt;
  public showSpinner = false;
  public spinnerRowIndex: number;
  public jobTaskStatus = JobTaskStatus;
  public jobTasks: any[];
  public completedJobTask = false;
  public toggleLabel: string;
  public projectId: any;
  public projectName: any;
  public level: Level;
  private intervalId!: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private route: ActivatedRoute,
              private levelService: LevelService,
              private jobTaskService: JobTaskService,
              private projectService: ProjectService,
              private eventMessageService: EventMessageService,
              private translateService: TranslateService,
              private statesService: StatesService,
              private toastr: ToastrService,
              private matDialog: MatDialog) {
  }

  ngOnInit(): void {
    this.projectId = this.route.snapshot.queryParams['project_id'] || this.statesService.selectedProject.getValue().id;
    this.load(this.projectId);
    this.updateToggleLabel();
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  load(projectId: number) {
    this.projectService.getProject(projectId).subscribe((project: any) => {
      this.projectName = ' - ' + project.name;
      this.level = project.level;
      this.statesService.stateLevelSubject.next(this.level);
      this.statesService.stateLevel = this.level.id;
      this.getJobTasks();
      this.intervalId = setInterval(() => {
        this.getJobTasks();
      }, 20000);

    });
  }

  getJobTasks() {
    this.isLoading = true;
    this.jobTaskService.getJobTasks(this.projectId, this.completedJobTask).subscribe(
      (result: any) => {
        this.jobTasks = result;
        this.jobTaskMatTableDataSource = new MatTableDataSource(this.jobTasks);
        this.jobTaskMatTableDataSource.paginator = this.paginator;
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }

  applyFilter(input: string) {
    this.jobTaskMatTableDataSource.filter = input.trim().toLowerCase();
  }

  view(jobTaskId) {
    const data = {
      jobTaskId,
    };
    this.matDialog.open(ExportCsvTaskModalComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }

  openExportModal(jobTask: JobTask) {
    const data = {
      start_date: jobTask.message.start_date,
      end_date: jobTask.message.end_date,
      idProject: jobTask.project_id,
      locationSelected: jobTask.message.location_ids,
      showSms: jobTask.message.from_sms,
      types: [
        {
          id: DataType.STATIC,
          selected: DataType.STATIC === jobTask.type
        }, {
          id: DataType.DYNAMIC,
          selected: DataType.DYNAMIC === jobTask.type
        }, {
          id: DataType.REALTIME,
          selected: DataType.REALTIME === jobTask.type
        }]
    };
    this.matDialog.open(ProjectExportCsvComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }

  cancel(jobTaskId: number, index: number) {
    this.showSpinner = true;
    this.spinnerRowIndex = index;
    this.jobTaskService.delete(jobTaskId).subscribe(() => {
      this.toastr.warning(this.translateService.instant('JOB_TASK_MESSAGE_CANCEL'));
      this.showSpinner = false;
      this.getJobTasks();
    });
  }

  toggle(event: any) {
    this.completedJobTask = !!event.checked;
    this.updateToggleLabel();
    this.getJobTasks();
  }

  updateToggleLabel() {
    if (this.completedJobTask) {
      this.translateService.get('JOB_STATUS_IN_COMPLETED').subscribe((text: string) => {
        this.toggleLabel = text;
      });
    } else {
      this.translateService.get('JOB_STATUS_ALL').subscribe((text: string) => {
        this.toggleLabel = text;
      });
    }
  }

}
